import { render, staticRenderFns } from "./stock-data-error.vue?vue&type=template&id=78d346d3&lang=pug"
import script from "./stock-data-error.vue?vue&type=script&lang=js"
export * from "./stock-data-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports